import styled from "@emotion/styled";
import { fontMerriweather, fontRobotoCondensed } from "@product/scmp-sdk";

import { SeriesArticleSectionTag } from "~/components/article/article-render/series-article/section-tag";
import { BaseImage } from "~/components/common/base-image";
import { ContentBookmark } from "~/components/content/content-bookmark";
import { EntityLink } from "~/components/entity-link";

export const Container = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;

  background-color: #141518;

  ${props => props.theme.breakpoints.up("tablet")} {
    min-block-size: 490px;
  }
`;

export const StyledEntityLink = styled(EntityLink)`
  position: absolute;
  inset-block-start: 0;
  inset-inline-start: 0;

  inline-size: 100%;
  block-size: 100%;
`;

export const StyledBaseImage = styled(BaseImage)`
  grid-row: 2 / 2;
  grid-column: 2 / 2;

  background-color: transparent;
`;

export const StyledContentBookmark = styled(ContentBookmark)`
  z-index: 1;

  inline-size: 14px;
  block-size: 15px;
  padding: 0;
`;

export const Title = styled.div`
  margin-block-end: 14px;

  color: #ffffff;
  font-weight: 900;
  font-size: 22px;
  font-family: ${fontMerriweather};
  line-height: 30px;
`;

export const SeriesSection = styled.div`
  margin-block-end: 8px;

  color: #ffca05;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  line-height: 19px;
  text-transform: capitalize;
`;

export const Time = styled.div`
  color: #999999;
  font-size: 14px;
  line-height: 14px;
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;

  padding-block: 15px 20px;
  padding-inline: 12px;
`;

export const Toolbar = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledSeriesArticleSectionTag = styled(SeriesArticleSectionTag)`
  margin-block-end: 8px;

  color: #ffca05;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  line-height: 19px;
  text-transform: capitalize;
`;
